<template>
    <div>
        <multiselect :id="id" v-model="outlet" :options="outlets" placeholder="Select Outlet" :custom-label="nameWithCode" label="name" track-by="name"></multiselect>
    </div>
</template>

<script>
import axios from '@/axios';
import Multiselect from 'vue-multiselect';
    export default {
        name: 'Outlets',
        components: {
            'multiselect': Multiselect
        },
        props: {
            id: {
                type: String,
                default: ''
            },
            modelValue: {
                type: '',
                default: '',
            }
        },
        data() {
            return {
                outlets: [],
                outlet: []
            }
        },
        created() {
            this.getOutlet();
            console.log('Outlet Selected', this.outlet);
        },
        methods: {
            getOutlet() {
                axios.get('outlet/getAll').then((res) => {
                console.log('outlets', res.data.data);
                res.data.data.forEach((val) => {
                    return this.outlets.push({
                    outletid: val.outletid,
                    name: val.name,
                    outlet_code: val.outlet_code
                    })
                });
                console.log('this.outlets', this.outlets);
                });
            },
            nameWithCode ({ name, outlet_code }) {
                return `${name} — [${outlet_code}]`
            },
        },
    }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css" lang="css"></style>